import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input', 'container']

  static values = {
    showContainerWhenInputOnIndexChecked: Number
  }

  connect() {
    this.updateContainerVisibility()
  }

  updateContainerVisibility() {
    const hideAndDisable = this.shouldHideAndDisableContainer

    this.toggleDisableAllInContainer(this.containerTarget, hideAndDisable)
    this.toggleVisibility(this.containerTarget, hideAndDisable)
  }

  toggleDisableAllInContainer(container, disableAll) {
    container.querySelectorAll('input, select').forEach((input) => {
      if (disableAll) {
        input.setAttribute('disabled', 'disabled')
      } else {
        input.removeAttribute('disabled')
      }
    })
  }

  toggleVisibility(elem, hide) {
    if (hide) {
      elem.classList.add('hidden')
    } else {
      elem.classList.remove('hidden')
    }
  }

  get shouldHideAndDisableContainer() {
    return !this.inputTargets[this.showContainerWhenInputOnIndexCheckedValue].checked
  }
}
